import {
  BrowserClient,
  defaultStackParser,
  getDefaultIntegrations,
  makeFetchTransport,
} from "@sentry/browser";
import { Scope } from "@sentry/svelte";

const integrations = getDefaultIntegrations({}).filter((defaultIntegration) => {
  return ![
    "BrowserApiErrors",
    "TryCatch",
    "Breadcrumbs",
    "GlobalHandlers",
  ].includes(defaultIntegration.name);
});

export default function setupSentry() {
  const client = new BrowserClient({
    dsn: "https://ce60aea2df912d69caa4b8ba8382eb57@o4507056478093312.ingest.us.sentry.io/4507057059069952",
    allowUrls: ["https://static.climate-app.pina.earth"],
    environment: process.env.NODE_ENV ?? "production",
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: integrations,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  const scope = new Scope();
  scope.setClient(client);

  client.init();
}
